import type { DemoKey } from './keys';

export const tl: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Matematika · 3D na Heometriya',
  'panel.figure': 'Hugis',
  'panel.dims': 'Mga Dimensyon',
  'panel.style': 'Hitsura',
  'panel.lines': 'Mga espesyal na linya',
  'style.body': 'Katawan',
  'style.line': 'Linya',
  'style.cut': 'Hiwa',
  'style.labels': 'Mga label ng vertex',
  'group.face': 'Dayagonal ng mukha / generador',
  'group.space': 'Dayagonal / aksis / medyan',
  'split.label': 'Hiwa',
  'btn.animate': 'I-animate',
  'btn.reset': 'I-reset',
  'hint.line1': 'I-drag para iikot · mag-scroll para mag-zoom',
  'hint.line2': 'I-click ang linya para piliin',
  'fig.cuboid': 'Kuboid',
  'fig.cube': 'Kubo',
  'fig.triPrism': 'Triyangulong prisma',
  'fig.hexPrism': 'Heksagonal na prisma',
  'fig.tetrahedron': 'Tetrahedro',
  'fig.squarePyramid': 'Kuwadradong pyramid',
  'fig.cylinder': 'Silindro',
  'fig.cone': 'Kono',
  'fig.sphere': 'Globo',
  'fig.frustumPyramid': 'Putol na pyramid',
  'fig.frustumCone': 'Putol na kono',
  'dim.length': 'haba',
  'dim.width': 'lapad',
  'dim.height': 'taas',
  'dim.side': 'gilid',
  'dim.radius': 'radius',
  'dim.r1': 'ibabang radius',
  'dim.r2': 'itaas na radius',
  'dim.sideBase': 'gilid ng base',
  'dim.sideTop': 'gilid sa itaas',
  'info.face': 'mukha',
  'info.center': 'dumadaan sa gitna',
  'info.diagonal': 'dayagonal',
  'info.axial': 'aksiyal na dayagonal',
  'info.diameter': 'diyametro',
  'info.generator': 'generador',
  'info.axis': 'aksis',
  'info.height': 'taas',
  'info.median': 'medyan',
  'info.apothem': 'apotema',
  'info.diameterBase': 'diyametro ng base',
  'info.diameterTop': 'diyametro sa itaas',
};
